import { Pipe, PipeTransform } from '@angular/core';
import { formatIstDate } from '../utils/ist-date';

/**
 * Formats timestamps in Asia/Kolkata (IST).
 * Naive Postgres/Supabase values are treated as UTC before conversion.
 *
 * Usage: {{ order.created_at | istDate:'medium' }}
 */
@Pipe({
  name: 'istDate',
  standalone: true,
  pure: true,
})
export class IstDatePipe implements PipeTransform {
  transform(
    value: string | number | Date | null | undefined,
    format = 'medium',
  ): string {
    return formatIstDate(value, format);
  }
}
